import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateDeliveryDevice } from 'app/dtos/deliveryDevice/updateDeliveryDevice';
import { UpdateDeliveryDevices } from 'app/dtos/deliveryDevice/updateDeliveryDevices';
import { CompanyService } from 'app/services/models/company.service';
import { DeliveryDeviceService } from 'app/services/models/delivery-device.service';
import { DeliveryMethodService } from 'app/services/models/delivery-method.service';
import { DeviceAcceptanceStatesService } from 'app/services/models/device-acceptance-states.service';
import { PersonService } from 'app/services/models/person.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-delivery-device-update-dialog',
  templateUrl: './delivery-device-update-dialog.component.html',
  styleUrls: ['./delivery-device-update-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeliveryDeviceUpdateDialogComponent implements OnInit {
  @Input() data: { id?: number; selectedIds?: number[]; companyId?: number, deliveryMethodId?: number };

  delivery: any = {};

  deliveryForm: FormGroup;

  companies: any[] = [];
  deliveryMethods: any[] = [];
  deviceAcceptances: any[] = [];
  companyPersons: any[] = [];
  persons: any[] = [];

  date = new Date();
  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };


  constructor(
    public ngbModal: NgbActiveModal,
    private deliveryDeviceService: DeliveryDeviceService,
    private companyService: CompanyService,
    private deliveryMethodService: DeliveryMethodService,
    private deviceAcceptanceStatesService: DeviceAcceptanceStatesService,
    private personService: PersonService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.deliveryForm = this.fb.group({
      deviceAcceptanceStatesId: [null, Validators.required],
      deliveryDate: [null],
      personId: [null],
      deliveryMethodId: [this.data.deliveryMethodId != null ? this.data.deliveryMethodId : null],
      deliveryPerson: [null],
    });

    await this.getAllDeliveryMethod();
    await this.getAllDeviceAcceptance();
    await this.getAllPersons(1);

    if (this.data.id != null)
      await this.getByIdDeliveryDevice(this.data.id);

  }

  async getByIdDeliveryDevice(id) {
    const data = await this.deliveryDeviceService.getByIdDeliveryDevice(id);
    console.log(data);
    this.delivery = data;
    this.date = data.deliveryDate ? new Date(data.deliveryDate) : new Date();


    //await this.getAllPersons(this.data.companyId)
    this.deliveryForm.patchValue({
      deviceAcceptanceStatesId: data.deviceAcceptanceStatesId ?? null,
      deliveryDate: this.date,
      personId: data.personId ?? null,
      deliveryMethodId: data.deliveryMethodId ?? null,
      deliveryPerson: data.deliveryPerson ?? null,
    });

  }

  async getAllCompanies() {
    const data = await this.companyService.getAllCompany('', 0, 1000);
    console.log(data);
    this.companies = data.companies;
  }

  async getAllDeliveryMethod() {
    const data = await this.deliveryMethodService.getAllDeliveryMethod(0, 100);
    console.log(data);
    this.deliveryMethods = data.deliveryMethods;
  }

  async getAllDeviceAcceptance() {
    const data = await this.deviceAcceptanceStatesService.getAllDeviceAcceptanceStates(0, 100);
    console.log(data);
    this.deviceAcceptances = data.deviceAcceptances;
  }

  async getAllPersons(id) {
    const data = await this.personService.getAllCompaniesPersons(0, 150, id);
    console.log(data);
    this.persons = data.persons;
  }

  closeModal() {
    this.ngbModal.close('Modal Kapatıldı.');
  }

  async onSumbit() {
    if (this.deliveryForm.valid) {
      console.log(this.deliveryForm.value);

      const deliveryDateValue = this.deliveryForm.value.deliveryDate
        ? new Date(this.deliveryForm.value.deliveryDate) // Date türüne çeviriyoruz
        : new Date();

      console.log(deliveryDateValue);

      const formData: UpdateDeliveryDevice = {
        id: this.delivery.id,
        deviceId: this.delivery.deviceId,
        deliveryId: this.delivery.deliveryId,
        deviceAcceptanceStatesId: this.deliveryForm.value.deviceAcceptanceStatesId,
        deliveryDate: deliveryDateValue,
        deliveryMethodId: this.deliveryForm.value.deliveryMethodId,
        companyId: this.delivery.companyId,
        isDeliveryStatus: false,
        deliveryCompanyPersonId: null,
        deliveryPerson: this.deliveryForm.value.deliveryPerson,
        personId: this.deliveryForm.value.personId,
        productId: this.delivery.productId
      };

      if (this.data.selectedIds?.length > 0) {
        console.log(this.data.selectedIds);
        const formData: UpdateDeliveryDevices = {
          ids: this.data.selectedIds,
          deviceAcceptanceStatesId: this.deliveryForm.value.deviceAcceptanceStatesId,
          deliveryDate: deliveryDateValue,
          deliveryMethodId: this.deliveryForm.value.deliveryMethodId,
          isDeliveryStatus: false,
          deliveryCompanyPersonId: null,
          deliveryPerson: this.deliveryForm.value.deliveryPerson,
          personId: this.deliveryForm.value.personId,
        };
        const data = await this.deliveryDeviceService.updateDeliveryDevices(formData);
        if (data.status) {
          this.deliveryDeviceService.sendEvent(true);
          this.toastrService.success(data.message);
          this.router.navigate(['/admin/delivery']);
          this.closeModal();
        } else {
          this.toastrService.error(data.message);
        }
      }
      else {
        const data = await this.deliveryDeviceService.updateDeliveryDevice(formData);
        if (data.status) {
          this.deliveryDeviceService.sendEvent(true);
          this.toastrService.success(data.message);
          this.closeModal();
        } else {
          this.toastrService.error(data.message);
        }
      }
    }
  }
}
